import * as types from './types';

export default {

    setAppliedFiltersCount({ commit }, payload) {
        commit(types.SET_APPLIED_FILTERS_COUNT, payload);
    },
};
